import { render, staticRenderFns } from "./UpdateTenancy.vue?vue&type=template&id=137146e1"
import script from "./UpdateTenancy.vue?vue&type=script&lang=js"
export * from "./UpdateTenancy.vue?vue&type=script&lang=js"
import style0 from "./UpdateTenancy.vue?vue&type=style&index=0&id=137146e1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports